import http, {makeSearchParams} from 'utils/http';

export const getSubscriptionPlans = (queries) => {
  return http('GET', `/g/subscription-plans`, queries);
};

export const getTotalSubscribers = () => {
  return http('GET', `/g/subscribers`);
};

export function postSubscribe(formData) {
  return http('POST', '/subscribe', formData);
}

export function postSubscribeTrial(formData) {
  return http('POST', '/subscribe/trial', formData);
}

export function postSubscribeTrialToBasic(formData) {
  return http('POST', '/subscribe/trial/basic', formData);
}

export function postSubscribeAddon(formData) {
  return http('POST', '/subscribe/addon', formData);
}

// GET subscription plan
export function getSubscription() {
  return http('GET', 'subscription');
}

export function deleteSubscription() {
  return http('DELETE', 'subscription');
}

export function getSubscriptionPaymentMethod() {
  return http('GET', 'subscription/payment-method');
}

export function putSubscriptionPaymentMethod(formData) {
  return http('PUT', 'subscription/payment-method', formData);
}

export function getSubscriptionProducts() {
  return http('GET', 'subscription-products');
}

export const getAccountSubscription = (queries) => {
  return http('GET', '/account/subscription', makeSearchParams(queries));
};

export const getSubscriptionDetails = () => {
  return http('GET', '/subscription-details');
};
